define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/comm",
	"csi/xml/Query",
	"./_RequestQueryMixin",
	"./Request"
], function(declare,_,comm,Query,_RequestQueryMixin,RequestStore) {

	return declare([RequestStore, _RequestQueryMixin], {
		idProperty: "id",
		queryClass: Query,
		requestBinaryParameter: comm.QUERY_XML,
		requestModule: "Charts",
		requestOperation: "GenerateChartJSON",

		// String[]: Chart does not support paging or sorting, so omit those options before calling server
		requestOmitOptions: ["count","direction","noActionData","queryOptions","sort","start","store"],

		// String[]: parameters to omit from Chart request
		requestOmitParameters: ["Crew.Scope","Fmt.AC.Policies","Fmt.AC.Rights","Fmt.Attr.Info","Fmt.Attr.List","Fmt.Complete","Fmt.Complete.Max","Fmt.Crew","Fmt.Node.Info"],


		_onResponse: function(/*Response*/res, /*Request*/req, /*Object*/options) {
			// summary: set store data for given response
			var	data = res.data.Charts;

			_.each(data, function(obj, i) {
				obj.id = i;
			});

			this._setData(data);
		}
	});
});